<template>
  <v-main>
    <v-card
      no-gutter
      class="card-live-data align-center justify-center text-center"
    >
      <v-container>
        <v-card-title class="headline mb-2">
          {{ $t("live.title") }}
          <v-spacer></v-spacer>
          <v-chip
            :color="active ? 'success' : 'error'"
            class="text-uppercase"
            >{{ active ? $t("live.statusOk") : $t("live.statusNo") }}</v-chip
          >
        </v-card-title>
      </v-container>
      <v-divider></v-divider>
      <div v-for="item in items" :key="item.imei" class="live-data">
        <v-row>
          <v-col cols="12" sm="2" md="1" style="padding: 0">
            <div
              style="max-width: 10px; height: 100% !important; margin: 0 auto"
            >
              <div :class="'bar ' + item.DataType + '-COLOR'"></div>
            </div>
          </v-col>

          <v-col cols="12" sm="5" md="5">
            <h4 style="margin-top: .5rem;">Imei:</h4>
            <span>{{ item.Imei }}</span>
            <h4 style="margin-top: .5rem;">SerialNumber:</h4>
            <span>{{ item.SerialNumber }}</span>
            <h4 style="margin-top: .5rem;">DataType:</h4>
            <span>{{ item.DataType }}</span>
            <h4 style="margin-top: .5rem;">Created At:</h4>
            <span>{{ item.CreatedAt }}</span>
          </v-col>

          <v-col cols="12" sm="5" md="6" style="padding: 0;">
            <v-main class="live-data-json">
              <vue-json-pretty
                style="margin: 1rem;"
                :deep="0"
                :data="item.Json"
              />
            </v-main>
          </v-col>
        </v-row>
      </div>

      <v-container fluid fill-height v-if="items.length <= 0">
        <v-row align="center" justify="center">
          <h1>{{ $t("live.waiting") }}</h1>
          <v-container style="width:100%">
            <v-progress-circular
              :size="70"
              :width="7"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-container>
        </v-row>
      </v-container>
    </v-card>
  </v-main>
</template>

<script>
import { format } from "date-fns";
import { mapState } from "vuex";

export default {
  name: "LiveDataBase",
  data() {
    return {
      items: [],
      socket: null,
      active: false
    };
  },

  async created() {
    if (this.socket == null) {
      var token = this.currentUser.token;
      let apiPath =
        process.env.NODE_ENV == "development"
          ? "http://localhost:5000"
          : process.env.VUE_APP_SO_API_BASE_URL;

      apiPath = apiPath.replace("https://", "");
      apiPath = apiPath.replace("http://", "");
      this.socket = new WebSocket(`ws://${apiPath}/ws?access_token=${token}`);
    }

    this.socket.onopen = this.onConnect;
    this.socket.onclose = this.onClose;
    this.socket.onmessage = this.onMessage;
    this.socket.onerror = function(event) {
      console.log("ERROR");
      console.log(event);
    };
  },
  methods: {
    onConnect() {
      this.active = true;
    },

    onClose() {
      // Display that the connection is not active anymore
      this.active = false;
    },

    onMessage(event) {
      try {
        let datas = JSON.parse(event.data);

        for (let d in datas) {
          datas[d].Json = JSON.parse(datas[d].Json);
          datas[d].CreatedAt = format(new Date(), "dd MMM - HH:mm");

          this.items.unshift(datas[d]);
        }

        if (this.items.length > 100) this.items.pop();
      } catch (e) {
        console.log("Could not parse JSON.", event);
      }
    }
  },

  computed: {
    ...mapState("users", ["currentUser", "userCompany", "hasCompany"])
  }
};
</script>

<style>
.live-data {
  width: 100%;
  max-height: 40vh;
}

.live-data {
  overflow-y: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
}
.live-data::-webkit-scrollbar {
  /* WebKit */
  width: 0;
  height: 0;
}

.live-data-json {
  text-align: left;
  background-color: rgb(255, 87, 34, 0.4);
  height: 100% !important;
}

.live-data::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}

.live-data:nth-of-type(2n) {
  background-color: #484747;
}

.card-live-data {
  width: 80% !important;
  height: 80vh !important;
  margin: 0 auto;
}

.card-live-data {
  overflow-y: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
}

.card-live-data::-webkit-scrollbar {
  /* WebKit */
  width: 0;
  height: 0;
}

.circle {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 0;
  padding: 50% 0;
  border-radius: 50%;
  margin: 0 auto;

  /* Just making it pretty */
  color: white;
  font-family: Helvetica, Arial Black, sans;
  font-size: 23px;
  text-align: center;
}

.DATAUPLINK-COLOR {
  background-color: #81d4fa;
}

.DEBUG-COLOR {
  background-color: #ff9100;
}

.HELLO-COLOR {
  background-color: #00e676;
}

.circle-title {
  font-size: 1rem;
}

.bar {
  height: 100% !important;
  width: 100% !important;
}
</style>
